export const DEFAULT_CONTACT_BLOCKTYPE = 'mail_contact';
export const MAIL_CONTACT_BLOCKTYPE = 'mail_contact';
export const PHONE_CONTACT_BLOCKTYPE = 'phone_contact';

export const MAIL_VALIDATION = /\S+@\S+\.\S+/;



// WEBPACK FOOTER //
// ./src/modules/edito/plugins/contact/constants.js